import { AgmOverlays } from 'agm-overlays';
import { LoginComponent } from './../../shared/dialogs/login/login.component';
import { SignupComponent } from './../../shared/dialogs/signup/signup.component';
import { QuestionModalComponent } from './../../shared/dialogs/question-modal/question-modal.component';
import { mapStyle } from './../../shared/styles/map-style';
import { MatSelectModule } from '@angular/material/select';
import { LanguageService } from './../../shared/services/language/language.service';
import { DataService } from './../../shared/services/data.service';
import { ShowMovieComponent } from './../../shared/dialogs/show-movie/show-movie.component';
import { AgmInfoWindow, MouseEvent, LatLngBounds, LatLngBoundsLiteral, AgmMap } from '@agm/core';
import { Component, OnInit, ViewChild, ElementRef, NgZone, EventEmitter, Output } from '@angular/core';
import { MatCarousel, MatCarouselComponent } from '@ngmodule/material-carousel';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { trigger, transition, style, animate, state } from '@angular/animations';
import { LoaderService } from 'src/app/shared/services/loader/loader.service';
import { AllQuestionModalComponent } from 'src/app/shared/dialogs/all-question-modal/all-question-modal.component';
import { QuestionCompleteModalComponent } from 'src/app/shared/dialogs/question-complete-modal/question-complete-modal.component';
import { IntroModalComponent } from 'src/app/shared/dialogs/intro-modal/intro-modal.component';
import { NavigationEnd, Router } from '@angular/router';


declare var google: any;

@Component({
  selector: 'app-global-classroom',
  templateUrl: './global-classroom.component.html',
  styleUrls: ['./global-classroom.component.scss']
})

export class GlobalClassroomComponent implements OnInit {

  checkExpandClick = false;

  currentIW: AgmInfoWindow;
  previousIW: AgmInfoWindow;
  style = mapStyle;

  isLoggedIn = false

  @Output() deleteItem = new EventEmitter();

  @ViewChild('selectSubject') selectSubject: ElementRef;
  @ViewChild('AgmMap') agmMap: AgmMap;
  @ViewChild('AgmMap2') agmMap2: ElementRef;
  @ViewChild('divToScrollMovie') divToScroll: ElementRef;

  @ViewChild('mapbanner') mapbanner: ElementRef;

  @ViewChild("MapHeader") mapHeader: ElementRef;
  @ViewChild("MapDiv") mapDiv: ElementRef;
  @ViewChild("MapVideoDiv") mapVideoDiv: ElementRef;

  @ViewChild('expeditionTab') expeditionTab: ElementRef;

  @ViewChild('tabSelected') tabSelected: ElementRef;

  // title = 'My first AGM project';

  zoom: number = 1;
  // lat = 51.678418;
  // lng = 7.809007;
  lat = 41.399115;
  lng = 2.160962;
  openedWindow: number = 0;

  AllMovies = [];

  blnLoader = false;

  lang: String = 'Dutch'; // change with user.lang

  langs = [
    { key: 'en', value: 'English' },
    { key: 'nl', value: 'Dutch' }
  ];

  public parentHeight = 'auto';
  public timings = '250ms ease-in';
  public autoplay = true;
  public interval = 5000;
  public loop = true;
  public hideArrows = false;
  public hideIndicators = false;

  public maxWidth = 'auto';
  public maintainAspectRatio = true;
  public proportion = 25;
  public slideHeight = '200px';

  public overlayColor = '#00000040';
  public hideOverlay = false;
  public useKeyboard = true;
  public useMouseWheel = false;
  // public orientation: Orientation = 'ltr';
  public log: string[] = [];


  allCountries = [];
  lstCountries = [{ id: 0, name: 'All countries' }];
  selectedCountry = 'All countries';
  selectedCountryId = 0;

  allSdg = [{ id: 0, name: 'All SDG’s' }];
  selectedSdg = 'All SDG’s';
  selectedSdgId = 0;

  allSubject = [{ id: 0, name: 'All subjects' }];
  selectedSubject = 'All subjects';
  selectedSubjectId = 0;

  // allCountriesExpedition = [];
  lstCountriesExpedition = [{ id: 0, name: 'All countries', image: './assets/images/world.svg' }];
  selectedCountryExpedition = 'All countries';
  selectedCountryIdExpedition = 0;
  selectedCountryImageExpedition = './assets/images/world.svg';

  allSubjectExpedition = [{ id: 0, name: 'All subjects' }];
  selectedSubjectExpedition = 'All subjects';
  selectedSubjectIdExpedition = 0;

  allSdgExpedition = [{ id: 0, name: 'All SDG’s', image: './assets/images/target.svg' }];
  selectedSdgExpedition = 'All SDG’s';
  selectedSdgIdExpedition = 0;
  selectedSdgImageExpedition = './assets/images/target.svg'

  allDifficultyExpedition = [
    {
      id: '',
      name: 'All'
    },
    {
      id: 1,
      name: 'Easy'
    },
    {
      id: 2,
      name: 'Medium'
    },
    {
      id: 3,
      name: 'Hard'
    }
  ];
  selectedDifficultyExpedition = 'All';
  selectedDifficultyIdExpedition: any = '';


  expeditionLat = 0;
  expeditionLong = 0;

  lstUnattendedQuestions = [];
  lstRightQuestions = [];
  lstWrongQuestions = [];

  Unattended = 0;
  rightQuestionLabel = 0;
  wrongQuestionLabel = 0;

  questionParams = {
    sdg: '',
    country: '',
    subject: '',
    offset: 0,
    difficulty: ''
  };


  countywiseData = [];
  filters = {};

  selectedLanguageSubscriber;
  selectedLanguage = '';

  // showinMapCountryQuestionList = [];

  isExpedition = false;

  lstExpeditionMap = [];
  lstAllSDGBanner = [];

  questionStatus: any = {
    'answered_questions': 0,
    'badge': "None",
    'maximum_score': 0,
    'attempted_percentage': 0,
    'score': 0,
    'total_questions': 0
  };
  participantData: any;
  userData: any;
  questionTabIndex = 0;
  infinityLoader = false;
  isQuestionListClear = false;
  // reloadSubscription: any;

  constructor(public dialog: MatDialog, private ngZone: NgZone, public serviceData: DataService, private translate: TranslateService, private languageservice: LanguageService, public loaderService: LoaderService, private router: Router) {
    this.selectedLanguageSubscriber = languageservice.translateLanguge.subscribe((value) => {
      this.selectedLanguage = value;
      // localStorage.setItem('laguage', value);
    });

    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };

    // this.router.routeReuseStrategy.shouldReuseRoute = function () {
    //   return false;
    // };
    // this.reloadSubscription = this.router.events.subscribe((event) => {
    //   if (event instanceof NavigationEnd) {
    //     // Trick the Router into believing it's last link wasn't previously loaded
    //     this.router.navigated = false;
    //   }
    // });
  }

  ngOnInit(): void {
    this.Unattended = 0;
    this.rightQuestionLabel = 0;
    this.wrongQuestionLabel = 0;
    this.initAfterLogin();

    this.loadVideoCountryList();

    // this.selectTab(1);
  }

  initAfterLogin() {
    if (localStorage.getItem('isUserLoggedin') == 'true') {
      this.isLoggedIn = true;
      this.userData = JSON.parse(localStorage.getItem('userData'));
      // console.log(this.userData);

      this.previousIW = undefined;
      this.currentIW = undefined;
      this.openedWindow = 0;

      // this.getSdgFilter();
      // this.getCountryFilter();
      // this.getSubjectList();
      // this.getAllMapCountries();
      // this.getSdgBannerList();
      // this.getParticipantData();

      // this.getQuestionList();
    }
  }

  ngAfterViewInit() {
    this.shortString();
    this.mapbanner?.nativeElement.addEventListener('wheel', this.onMouseEnter);
    this.selectTab(1);
  }

  tabChanged(tabChangeEvent) {
    this.clearInfowindowCountry();
    // console.log('index => ', tabChangeEvent.index);
    if (tabChangeEvent.index == 0) {
      this.isExpedition = false;
      // this.loadVideoCountryList();
    } else if (tabChangeEvent.index == 1) {
      this.expeditionLat = 0;
      this.expeditionLong = 0;
      this.isExpedition = true;
      this.checkExpandClick = false;
      this.reset();
      // if (localStorage.getItem('isUserLoggedin') == 'true') {
      //   this.getSdgFilter();
      // } else {
      //   this.getSdgPubliFilter();
      // }
    }
  }

  selectTab(index) {
    this.clearInfowindowCountry();
    if (index == 0) {
      this.isExpedition = false;
      this.setVideoTrayHeight();
    } else if (index == 1) {
      this.expeditionLat = 0;
      this.expeditionLong = 0;
      this.isExpedition = true;
      this.checkExpandClick = false;
      this.setQnTrayHeight();
      this.reset();
    }
  }


  // ************************* Starting of Video *************************
  // get video country list api
  loadVideoCountryList() {
    this.loaderService.display(true);
    this.serviceData.getCountryPublicFilter().subscribe((resp: any) => {
      this.loaderService.display(false);
      this.lstCountries = [{ id: 0, name: 'All countries' }];
      // this.selectedCountry = 'All countries';
      // this.selectedCountryId = 0;
      if (resp.success) {
        this.allCountries = resp.data.results;
        // console.log('allCountries', this.allCountries);
        this.lstCountries.push(...resp.data.results);
        // console.log('lstCountries', this.lstCountries);
        this.loadSdgList();
      }
    }, Error => {
      console.log('Err is ', Error);
      this.loaderService.display(false);
    });
  }

  // get video sdg list api
  loadSdgList() {
    this.loaderService.display(true);
    this.serviceData.getSDGPublicfilter().subscribe((resp: any) => {
      this.loaderService.display(false);
      // console.log(resp.data.results);
      this.allSdg = [{ id: 0, name: 'All SDG’s' }];
      if (resp.success) {
        this.allSdg.push(...resp.data.results);
        this.loadVideoSubjectList();
      }
    }, Error => {
      this.loaderService.display(false);
      console.log('Err is ', Error);
    });
  }

  // get video subject list api
  loadVideoSubjectList() {
    this.loaderService.display(true);
    this.serviceData.getSubjectPublicList().subscribe((resp: any) => {
      this.loaderService.display(false);
      // console.log(resp.data.results);
      this.allSubject = [{ id: 0, name: 'All subjects' }];
      if (resp.success) {
        this.allSubject.push(...resp.data.results);
        this.loadCountryVideoList();
      }
    }, Error => {
      console.log('Err is ', Error);
      this.loaderService.display(false);
    });
  }

  // load country wise video list api
  loadCountryVideoList() {
    let params = {
      'sdg': this.selectedSdgId == 0 ? '' : this.selectedSdgId,
      'country': this.selectedCountryId == 0 ? '' : this.selectedCountryId,
      'subject': this.selectedSubjectId == 0 ? '' : this.selectedSubjectId
    }
    this.loaderService.display(true);
    // console.log('country wise video()', params);
    this.countywiseData = [];
    this.serviceData.getCountryVideoList(params).subscribe((resp: any) => {
      this.loaderService.display(false);
      // this.countywiseData = resp.data.results;

      resp.data.results.forEach(element => {
        if (element.country_videos.length != 0) {
          this.countywiseData.push(element);
        }
      });
      if (this.countywiseData.length == 0) {
        this.countywiseData = resp.data.results;
      }
      // console.log('countywiseData', this.countywiseData);

      // add thumbnail for map info window slides
      this.movieMakeThumbnail(this.countywiseData);

      this.loadVideoList()
    }, Error => {
      this.loaderService.display(false);
      console.log('Err is ', Error);
    });
  }

  // load videolist api
  loadVideoList() {
    let params = {
      'sdg': this.selectedSdgId == 0 ? '' : this.selectedSdgId,
      'country': this.selectedCountryId == 0 ? '' : this.selectedCountryId,
      'subject': this.selectedSubjectId == 0 ? '' : this.selectedSubjectId
    }
    this.loaderService.display(true);
    // console.log('loadVideoList()', params);
    this.serviceData.getVideoList(params).subscribe((resp: any) => {
      // console.log(resp.data.results);
      this.AllMovies = resp.data.results;

      // add thumbnail for all videos in left side
      this.movieThumbnailAllvideos(this.AllMovies);
      this.loaderService.display(false);
    }, Error => {
      this.loaderService.display(false);
      console.log('Err is ', Error);
    });

  }

  //  country filter
  countryChange(country) {
    // this.blnLoader = true;

    this.loadCountryVideoList();

    this.previousIW = undefined;

    // to open info window of selected country
    this.openedWindow = country;
    this.checkExpandClick = true;

    this.divToScroll.nativeElement.scrollTop = 0;
  }

  // sdg filter
  sdgChange(sdg) {
    // this.blnLoader = true;

    this.loadCountryVideoList();

    this.previousIW = undefined;
    this.currentIW = undefined;

    this.divToScroll.nativeElement.scrollTop = 0;
    if (this.selectedCountryId != 0) {
      this.openedWindow = this.selectedCountryId;
    }
    else {
      this.openedWindow = 0;
    }
  }

  // subject filter
  subjectChange(index) {
    // this.blnLoader = true;

    this.loadCountryVideoList();

    this.clearInfowindowCountry();
    this.divToScroll.nativeElement.scrollTop = 0;
    if (this.selectedCountryId != 0) {
      this.openedWindow = this.selectedCountryId;
    }
    else {
      this.openedWindow = 0;
    }
  }

  clearFilter() {
    this.selectedCountryId = 0;
    this.selectedSdgId = 0;
    this.selectedSubjectId = 0;
    this.clearInfowindowCountry();
    this.checkExpandClick = false;

    this.loadVideoCountryList();
  }

  // to expand left side window
  expandClick() {
    this.checkExpandClick = !this.checkExpandClick;
  }

  // thumbnail creation for map videos
  movieMakeThumbnail(countywiseData) {
    countywiseData.forEach(country => {
      country.country_videos.forEach(movie => {
        let vt = movie.link.split('?');
        movie['movieThumbnail'] = '//i.ytimg.com/vi/' + vt[0].substring(30) + '/hqdefault.jpg';
        movie['current_slide'] = 0;
      });
    });
  }

  //  thumbnail creation for left side all videos
  movieThumbnailAllvideos(allmovie) {
    allmovie.forEach(element => {
      let vt = element.link.split('?');
      element['movieThumbnail'] = '//i.ytimg.com/vi/' + vt[0].substring(30) + '/hqdefault.jpg';
    });
  }

  //  open video showing modal window
  movieClick(movie, infoWindow) {
    if (infoWindow) {
      if (this.previousIW) {
        this.currentIW = infoWindow;
        this.previousIW.close();
      }
      this.previousIW = infoWindow;
    }
    else if (this.previousIW) {
      this.previousIW.close();
    }

    const dialogRef = this.dialog.open(ShowMovieComponent, {
      disableClose: true,
      width: '800px',
      height: 'auto',

      data: { 'movie': movie, 'quizVideo': false }
    });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed', result);
    });

  }

  //  to update current slide number
  updateSlider(event, country_videos) {
    country_videos[0].current_slide = event;
  }

  showAllVideos(country, infoWindow) {
    // this.blnLoader = true;

    this.selectedCountryId = country.id;
    this.selectedSdgId = 0;
    this.selectedSubjectId = 0;

    if (this.checkExpandClick == false) {
      this.checkExpandClick = true;
    }
    if (infoWindow) {
      if (this.previousIW) {
        this.currentIW = infoWindow;
        this.previousIW.close();
      }
      this.previousIW = infoWindow;
    }
    // this.countryChange(country.id);
    this.loadVideoList();

  }

  // marker click
  markerCliked(country) {
    if (country != undefined && country.country_videos.length != 0) {
      // this.blnLoader = true;
      this.selectedCountryId = country.id;
      this.checkExpandClick = true;

      this.countryChange(this.selectedCountryId);
    }
  }

  closeInfoWindow(countryList, countyData?) {
    if (this.selectedCountryId != 0) {
      this.clearFilter();
    }
    else {
      this.previousIW = undefined;
      this.currentIW = undefined;
      this.openedWindow = 0;
      this.zoom = 2;
      this.agmMap.mapReady.subscribe(map => {
        const bounds: LatLngBounds = new google.maps.LatLngBounds();
        for (const mm of countryList) {
          bounds.extend(new google.maps.LatLng(mm.lat, mm.lng));
        }
        map.fitBounds(bounds);
      });
    }

  }

  // marker hover
  clickedMarker(label: string, country, infoWindow) {
    this.clearInfowindowSdg();
    if (this.previousIW) {
      this.currentIW = infoWindow;
      this.previousIW.close();
      this.currentIW.open()
    }
    this.previousIW = infoWindow;
    this.currentIW = infoWindow
    this.currentIW.open()

    this.openedWindow = country.id;
  }

  isInfoWindowOpen(id) {
    return this.openedWindow == id; // alternative: check if id is in array
  }

  infoCloseOnMouseLeave(label: string, index: number, infoWindow) {
    // console.log(`leve the marker: ${label || index}`);
    this.currentIW.close()
  }

  onMouseEnter() {
    // (<Element>event.target).parentElement.scrollLeft += event.deltaY;
    // event.preventDefault();
    // alert("Don't touch my bacon!")
  }

  videoMapReady(e) {
    console.log(e);
    // const bounds: LatLngBounds = new google.maps.LatLngBounds();
    // for (let marker of this.lstExpeditionMap) {
    //   bounds.extend(new google.maps.LatLng(marker.latitude, marker.longitude));
    // }
    // e.fitBounds(bounds);
    setTimeout(() => {
      this.mapVideoDiv.nativeElement.style.paddingTop = this.mapHeader.nativeElement.offsetHeight + 13 + 'px';
    }, 1000);
  }

  //to handle the lengthy drodown option content
  shortString() {
    var e = document.querySelectorAll(".selectSubject");
    e.forEach(x => {
      if (x.textContent.length > 20)
        x.textContent = x.textContent.substring(0, 20) + '...';
    })
  }

  // ************************* ending of Video *************************

  // translation function
  setLang(lang: string) {
    this.translate.use(lang);
    // localStorage.setItem('userLang', lang);
    if (lang == 'en') {
      this.lang = 'English';
      localStorage.setItem('userLang', lang);
    } else if (lang == 'nl') {
      this.lang = 'Dutch';
      localStorage.setItem('userLang', lang);
    }
    this.reloadPageFunction();
  }

  reloadPageFunction() {
    this.router.navigate([this.router.url])
    console.log('reload')
    // this.router.navigateByUrl('/');
  }

  // expodation marker clicked
  expeditionMarkerCliked(country) {
    this.selectedCountryIdExpedition = country.id;
    this.selectedSdgExpedition = 'All SDG’s';
    this.selectedSdgImageExpedition = './assets/images/target.svg'
    this.selectedSdgIdExpedition = 0;
    this.questionParams.sdg = '';
    this.selectedSubjectIdExpedition = 0;
    this.questionParams.subject = '';

    this.selectedDifficultyIdExpedition = '';
    this.questionParams.difficulty = '';

    this.countryChangeExpedition(country.id)

    // this.difficultyChangeExpedition('');

    if (country.info.answered_questions < country.info.total_questions) {
      this.startPlaying();
    } else {
      this.questionStatus = {
        'answered_questions': country.info.answered_questions,
        'badge': country.info.badge,
        'maximum_score': country.info.maximum_score,
        'attempted_percentage': 0,
        'score': country.info.score,
        'total_questions': country.info.total_questions
      }
      this.viewQuestionCompleted();
    }
  }

  closeInfoWindow2(countryList) {
    console.log(this.agmMap2)
    this.clearInfowindowCountry();
    let a = this.lstExpeditionMap;
    this.lstExpeditionMap = [];
    setTimeout(() => {
      this.lstExpeditionMap = a;
    }, 1);

  }

  closeBannerInfo(banner) {
    banner.bannerClicked = false;
    console.log('close sdg IW', banner);
  }

  getSdgPubliFilter() {
    this.loaderService.display(true);
    this.serviceData.getSDGPublicfilter().subscribe((resp: any) => {
      console.log(resp)
      this.allSdgExpedition = [{ id: 0, name: 'All SDG’s', image: './assets/images/target.svg' }];
      if (resp.success) {
        this.allSdgExpedition.push(...resp.data.results);
        this.getCountryPublicFilter();
      }
    }, Error => {
      this.loaderService.display(false);
      console.log('Err is ', Error);
    });
  }
  getCountryPublicFilter() {
    this.lstCountriesExpedition = [{ id: 0, name: 'All countries', image: './assets/images/world.svg' }];
    this.serviceData.getCountryPublicFilter().subscribe((resp: any) => {
      if (resp.success) {
        console.log(resp.data.results)
        this.lstCountriesExpedition.push(...resp.data.results);
        this.getSubjectPublicList();
      }
    }, Error => {
      console.log('Err is ', Error);
      this.loaderService.display(false);
    });
  }
  getSubjectPublicList() {
    this.serviceData.getSubjectPublicList().subscribe((resp: any) => {
      if (resp.success) {
        this.allSubjectExpedition.push(...resp.data.results);
        this.getAllPublicMapCountries();
        // this.getQuestionPublicList();
      }
    }, Error => {
      console.log('Err is ', Error);
      this.loaderService.display(false);
    });
  }

  getAllPublicMapCountries() {
    this.serviceData.getCountriesPublicMap().subscribe((resp: any) => {
      if (resp.success) {
        this.lstExpeditionMap = resp.data.results;
        this.lstExpeditionMap.forEach((country: any) => {
          country.info.score = 0;
          country.info.badge = 'None';
          country.info.answered_questions = 0;
          country.info.score_percentage = 0;
          if (country.info.score_percentage < 20) {
            country.upComingBadge = 'bronze';
            let x = Math.ceil(((20 * country.info.maximum_score) / 100));
            country.pointNeed = x;
          } else if (country.info.score_percentage >= 20 && country.info.score_percentage < 50) {
            country.upComingBadge = 'silver';
            let x = Math.ceil(((50 * country.info.maximum_score) / 100));
            country.pointNeed = x;
          } else if (country.info.score_percentage >= 50 && country.info.score_percentage < 80) {
            country.upComingBadge = 'gold';
            let x = Math.ceil(((80 * country.info.maximum_score) / 100));
            country.pointNeed = x;
          }
        });
        console.log(this.lstExpeditionMap);
        this.getQuestionPublicList();
      }
    }, Error => {
      this.loaderService.display(false);
      console.log('Err is ', Error);
    });
  }

  // getQuestionPublicList() {
  //   this.lstRightQuestions = [];
  //   this.lstWrongQuestions = [];
  //   this.lstUnattendedQuestions = [];
  //   this.serviceData.getQuestionPublicList(this.questionParams).subscribe((resp: any) => {
  //     if (resp.success) {
  //       let allQuestionList = resp.data.results;
  //       console.log(allQuestionList);
  //       allQuestionList.forEach(element => {
  //         element.score = 0;
  //         if (element.attempted) {
  //           if (element.is_right) {
  //             this.lstRightQuestions.push(element);
  //           } else {
  //             this.lstWrongQuestions.push(element);
  //           }
  //         } else {
  //           this.lstUnattendedQuestions.push(element);
  //         }
  //       });
  //       this.Unattended = this.translate.instant('Unattended') + '(' + this.lstUnattendedQuestions.length + ')';
  //       this.rightQuestionLabel = this.translate.instant('Right') + '(' + this.lstRightQuestions.length + ')';
  //       this.wrongQuestionLabel = this.translate.instant('Wrong') + '(' + this.lstWrongQuestions.length + ')';
  //       this.getQuestionPublicStatus();
  //     }
  //   }, Error => {
  //     this.loaderService.display(false);
  //     console.log('Err is ', Error);
  //   });
  // }

  getQuestionPublicList() {
    this.getQuestionList();
  }

  onPublicQuestionScroll() {
    this.infinityLoader = true;
    if (!this.isQuestionListClear) {
      this.questionParams.offset = this.lstUnattendedQuestions.length;
    }
    this.serviceData.getQuestionPublicList(this.questionParams).subscribe((resp: any) => {
      if (resp.success) {
        this.clearQuestionList();
        this.lstUnattendedQuestions.push(...resp.data.results)
        this.Unattended = resp.data.count;
        this.rightQuestionLabel = 0;
        this.wrongQuestionLabel = 0;
      }
      this.infinityLoader = false;
    }, Error => {
      this.infinityLoader = false;
      this.loaderService.display(false);
      console.log('Err is ', Error);
    });
  }

  getQuestionPublicStatus() {
    this.serviceData.getQuestionPublicStatus(this.questionParams).subscribe((resp: any) => {
      if (resp.success) {
        console.log(resp.data);
        this.questionStatus = resp.data;
        this.questionStatus.answered_questions = 0;
        this.questionStatus.score = 0;
        this.questionStatus.badge = 'None';
      }
      this.loaderService.display(false);
    }, Error => {
      this.loaderService.display(false);
      console.log('Err is ', Error);
    });
  }

  viewSdgQuestions(sdg) {
    sdg.bannerClicked = false;
    this.selectedSdgIdExpedition = sdg.id;
    this.selectedCountryExpedition = 'All countries';
    this.selectedCountryIdExpedition = 0;
    this.questionParams.country = '';
    this.selectedSubjectIdExpedition = 0;
    this.questionParams.subject = '';
    this.selectedCountryImageExpedition = './assets/images/world.svg';

    this.selectedDifficultyIdExpedition = '';
    this.questionParams.difficulty = '';

    this.sdgChangeExpedition(sdg.id);

    this.questionTabIndex = 0;

    // this.difficultyChangeExpedition('');

    if (sdg.info.answered_questions < sdg.info.total_questions) {
      this.startPlaying();
    } else {
      this.questionStatus = {
        'answered_questions': sdg.info.answered_questions,
        'badge': sdg.info.badge,
        'maximum_score': sdg.info.maximum_score,
        'attempted_percentage': 0,
        'score': sdg.info.score,
        'total_questions': sdg.info.total_questions
      }
      this.viewQuestionCompleted();
    }
  }

  viewSingleQuestion(questionId, stataus) {
    if (this.isLoggedIn) {
      let data = {
        isSingleQuestion: true,
        questionId: questionId,
        // sdg: '',
        // country: '',
        // subject: ''
        sdg: this.questionParams.sdg,
        country: this.questionParams.country,
        subject: this.questionParams.subject,
        difficulty: this.questionParams.difficulty,
        view: stataus
      }
      this.viewQuestion(data);
    }
    else {
      this.signup();

      // const dialogRef = this.dialog.open(SignupComponent, {
      //   disableClose: true,
      //   width: '544px',
      //   height: 'auto',
      //   panelClass: 'custom-dialog-container'
      // });
      // dialogRef.afterClosed().subscribe(result => {
      //   if (result == 'success') {
      //     this.isLoggedIn = true;
      //     this.userData = JSON.parse(localStorage.getItem('userData'));
      //     this.previousIW = undefined;
      //     this.currentIW = undefined;
      //     this.openedWindow = 0;
      //     this.introModalOpen();
      //   } if (result == 'login') {
      //     this.login();
      //   }
      // });

    }
  }

  viewFilterQuestion() {
    let data = {
      isSingleQuestion: false,
      questionId: '',
      sdg: this.questionParams.sdg,
      country: this.questionParams.country,
      subject: this.questionParams.subject,
      difficulty: this.questionParams.difficulty,
      view: false
    }
    this.viewQuestion(data);
  }

  viewQuestion(data) {
    this.clearInfowindowSdg();
    this.clearInfowindowCountry();

    const dialogRef = this.dialog.open(QuestionModalComponent, {
      disableClose: true,
      width: '978px',
      // height: 'auto',
      // minHeight: '60vh',
      maxWidth: '90vw',
      height: '85vh',
      data: data
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result)
      if (result == 'completed') {
        this.quizScrollToTop();
        this.loaderService.display(true);
        this.serviceData.getQuestionStatus(this.questionParams).subscribe((resp: any) => {
          if (resp.success) {
            console.log(resp.data);
            this.questionStatus = resp.data;
            this.serviceData.getParticipantData().subscribe((resp: any) => {
              if (resp.success) {
                console.log(resp.data);
                this.participantData = resp.data;
                this.loaderService.display(false);
                // this.viewQuestionCompleted()
                if (!(data.difficulty != '')) {
                  this.viewQuestionCompleted();
                }
              }
            }, Error => {
              this.loaderService.display(false);
              console.log('Err is ', Error);
            });
          }
        }, Error => {
          this.loaderService.display(false);
          console.log('Err is ', Error);
        });
      } else if (result == 'next') {
        this.loaderService.display(true);
        this.serviceData.getSDGlist().subscribe((resp: any) => {
          if (resp.success) {
            console.log(resp.data)
            this.lstAllSDGBanner = resp.data.results;
            this.lstAllSDGBanner.forEach(element => {
              element['bannerClicked'] = false;
              element.info.percentage = Math.round((element.info.answered_questions / element.info.total_questions) * 100);
            });
            this.loaderService.display(false);
            this.openSdgFromQstn()
          }
        }, Error => {
          this.loaderService.display(false);
          console.log('Err is ', Error);
        });

      } else if (result == 'close') {
        console.log('pop up closed');
      } else {
        this.quizScrollToTop();
        this.loaderService.display(true);
        this.getAllMapCountries();
      }
      // this.lstCountriesExpedition = [{ id: 0, name: 'All countries' }];
      // this.allSubjectExpedition = [{ id: 0, name: 'All subjects' }];

      // this.allSdgExpedition = [{ id: 0, name: 'All SDG’s' }];
      // this.getSdgFilter();
      // this.initAfterLogin();
    });
  }

  viewQuestionCompleted() {
    const dialogRef = this.dialog.open(QuestionCompleteModalComponent, {
      disableClose: true,
      width: '544px',
      // height: 'auto',
      minHeight: '60vh',
      data: this.questionStatus
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 'next') {
        this.loaderService.display(true);
        this.serviceData.getSDGlist().subscribe((resp: any) => {
          if (resp.success) {
            console.log(resp.data)
            this.lstAllSDGBanner = resp.data.results;
            this.lstAllSDGBanner.forEach(element => {
              element['bannerClicked'] = false;
              element.info.percentage = Math.round((element.info.answered_questions / element.info.total_questions) * 100);
            });
            this.loaderService.display(false);
            this.openSdgFromQstn()
          }
        }, Error => {
          this.loaderService.display(false);
          console.log('Err is ', Error);
        });

      } else {
        this.loaderService.display(true);
        this.getAllMapCountries();
      }

    });
  }

  openSdgFromQstn() {
    const dialogRef = this.dialog.open(AllQuestionModalComponent, {
      disableClose: true,
      // width: '978px',
      width: '1023px',
      maxWidth: '85vw',
      // height: 'auto',
      minHeight: '60vh',
      maxHeight: '80vh',
      data: this.lstAllSDGBanner
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result)
      this.loaderService.display(true);
      this.getAllMapCountries();
      if (result != undefined) {
        this.viewSdgQuestions(result)
      }
    });
  }

  previousClick() {
    let scrollLeft = this.mapbanner.nativeElement.scrollLeft;
    let scrollWidth = this.mapbanner.nativeElement.scrollWidth;
    let offsetWidth = this.mapbanner.nativeElement.offsetWidth;

    if (scrollLeft == 0) {
      this.mapbanner.nativeElement.scrollLeft = scrollWidth - offsetWidth;
    } else {
      this.mapbanner.nativeElement.scrollLeft -= 760;
    }
    this.lstAllSDGBanner.forEach((element, i) => {
      element.bannerClicked = false;
    });
  }

  nextClick() {
    let scrollLeft = this.mapbanner.nativeElement.scrollLeft;
    let scrollWidth = this.mapbanner.nativeElement.scrollWidth;
    let offsetWidth = this.mapbanner.nativeElement.offsetWidth;

    if (scrollLeft == scrollWidth - offsetWidth) {
      this.mapbanner.nativeElement.scrollLeft = 0;
    } else {
      this.mapbanner.nativeElement.scrollLeft += 760;
    }
    this.lstAllSDGBanner.forEach((element, i) => {
      element.bannerClicked = false;
    });
  }
  signup() {
    const dialogRef = this.dialog.open(SignupComponent, {
      disableClose: true,
      width: '550px',
      height: 'auto',
      maxHeight: '90vh',
      panelClass: 'custom-dialog-container'

      // data: { 'question': movie }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('Signup dialog was closed', result);
      if (result == 'success') {
        this.isLoggedIn = true;
        this.userData = JSON.parse(localStorage.getItem('userData'));
        this.previousIW = undefined;
        this.currentIW = undefined;
        this.openedWindow = 0;
        this.questionParams = {
          sdg: '',
          country: '',
          subject: '',
          offset: 0,
          difficulty: ''
        };
        this.introModalOpen();
        // this.quizScrollToTop();

        this.reset();
      } else if (result == 'login') {
        this.login();
      } else if (result == 'videos') {
        this.selectTab(0);
      }
    });
  }

  reset() {
    this.lstCountriesExpedition = [{ id: 0, name: 'All countries', image: './assets/images/world.svg' }];
    this.selectedCountryExpedition = 'All countries';
    this.selectedCountryIdExpedition = 0;
    this.selectedCountryImageExpedition = './assets/images/world.svg';

    this.allSubjectExpedition = [{ id: 0, name: 'All subjects' }];
    this.selectedSubjectExpedition = 'All subjects';
    this.selectedSubjectIdExpedition = 0;

    this.allSdgExpedition = [{ id: 0, name: 'All SDG’s', image: './assets/images/target.svg' }];
    this.selectedSdgExpedition = 'All SDG’s';
    this.selectedSdgImageExpedition = './assets/images/target.svg'
    this.selectedSdgIdExpedition = 0;

    this.selectedDifficultyExpedition = 'All';
    this.selectedDifficultyIdExpedition = '';

    this.lstExpeditionMap = [];

    this.questionStatus = {
      'answered_questions': 0,
      'badge': "None",
      'maximum_score': 0,
      'attempted_percentage': 0,
      'score': 0,
      'total_questions': 0
    }

    this.questionParams = {
      sdg: '',
      country: '',
      subject: '',
      offset: 0,
      difficulty: ''
    };

    // this.getSdgPubliFilter();

    this.quizScrollToTop();
    if (localStorage.getItem('isUserLoggedin') == 'true') {
      this.getSdgFilter();
    } else {
      this.getSdgPubliFilter();
    }
    if (!this.isExpedition) {
      this.mapVideoDiv.nativeElement.style.paddingTop = this.mapHeader.nativeElement.offsetHeight + 13 + 'px';
    }
  }

  signOut() {
    this.isLoggedIn = false;
    // this.quizScrollToTop();
    localStorage.removeItem('isUserLoggedin');
    localStorage.removeItem('userData');
    this.reset();
  }

  login() {
    const dialogRef = this.dialog.open(LoginComponent, {
      disableClose: true,
      width: '544px',
      height: 'auto',
      maxHeight: '90vh',
      panelClass: 'custom-dialog-container'

      // data: { 'question': movie }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('login dialog was closed', result);
      if (result == 'success') {
        this.isLoggedIn = true;
        this.userData = JSON.parse(localStorage.getItem('userData'));

        this.previousIW = undefined;
        this.currentIW = undefined;
        this.openedWindow = 0;
        this.questionParams = {
          sdg: '',
          country: '',
          subject: '',
          offset: 0,
          difficulty: ''
        };
        // this.getSdgFilter();
        // this.quizScrollToTop();

        this.reset();
      } else if (result == 'signup') {
        this.signup();
      }
    });
  }
  bannerClicked(banner, index, event) {
    //  clear map IW
    this.clearInfowindowCountry();

    let el = document.getElementById(banner.id);
    const offsetLeft = el.getBoundingClientRect().left - el.offsetParent.getBoundingClientRect().left;

    const offsetRight = el.offsetParent.getBoundingClientRect().right - el.getBoundingClientRect().right;
    this.lstAllSDGBanner.forEach((element, i) => {
      if (index == i) {
        element.bannerClicked = true;
        setTimeout(() => {
          if (offsetLeft >= offsetRight) {
            document.getElementById("info" + banner.id).classList.add('tool-tip-right');
            document.getElementById("info" + banner.id).style.right = offsetRight + 22 + "px";
          } else {
            if (document.getElementById("info" + banner.id).classList.contains('tool-tip-right')) {
              document.getElementById("info" + banner.id).classList.remove('tool-tip-right');
            }
            document.getElementById("info" + banner.id).style.left = offsetLeft + 22 + "px";
          }
        }, 1);
      }
      else {
        element.bannerClicked = false;
      }
    });

  }

  clearInfowindowSdg() {
    this.lstAllSDGBanner.forEach((element, i) => {
      element.bannerClicked = false;
    });
  }

  clearInfowindowCountry() {
    this.previousIW = undefined;
    this.currentIW = undefined;
    this.openedWindow = 0;
  }

  startPlaying() {
    if (this.isLoggedIn) {
      this.viewFilterQuestion();
    }
    else {
      this.signup();

      // const dialogRef = this.dialog.open(SignupComponent, {
      //   disableClose: true,
      //   width: '544px',
      //   height: 'auto',
      //   panelClass: 'custom-dialog-container'
      // });
      // dialogRef.afterClosed().subscribe(result => {
      //   if (result == 'success') {
      //     this.isLoggedIn = true;
      //     this.userData = JSON.parse(localStorage.getItem('userData'));
      //     this.previousIW = undefined;
      //     this.currentIW = undefined;
      //     this.openedWindow = 0;
      //     this.introModalOpen();
      //   } if (result == 'login') {
      //     this.login();
      //   }
      // });
    }
  }
  getSdgFilter() {
    this.loaderService.display(true);
    this.serviceData.getSDGfilter().subscribe((resp: any) => {
      console.log(resp)
      this.allSdgExpedition = [{ id: 0, name: 'All SDG’s', image: './assets/images/target.svg' }];
      this.selectedSdgExpedition = 'All SDG’s';
      this.selectedSdgIdExpedition = 0;
      this.questionParams.sdg = '0';
      this.selectedSdgImageExpedition = './assets/images/target.svg'
      if (resp.success) {
        this.allSdgExpedition.push(...resp.data.results);
        this.getCountryFilter();
      }
    }, Error => {
      this.loaderService.display(false);
      console.log('Err is ', Error);
    });
  }
  getCountryFilter() {
    this.serviceData.getCountryFilter().subscribe((resp: any) => {
      if (resp.success) {
        this.lstCountriesExpedition = [{ id: 0, name: 'All countries', image: './assets/images/world.svg' }];
        this.selectedCountryExpedition = 'All countries';
        this.selectedCountryIdExpedition = 0;
        this.questionParams.country = '0';
        this.selectedCountryImageExpedition = './assets/images/world.svg';
        console.log(resp.data.results)
        this.lstCountriesExpedition.push(...resp.data.results);
        this.getSubjectList();
      }
    }, Error => {
      console.log('Err is ', Error);
      this.loaderService.display(false);
    });
  }
  getSubjectList() {
    this.serviceData.getSubjectList().subscribe((resp: any) => {
      if (resp.success) {
        this.allSubjectExpedition = [{ id: 0, name: 'All subjects' }];
        this.selectedSubjectExpedition = 'All subjects';
        this.selectedSubjectIdExpedition = 0;
        this.questionParams.subject = '0';
        this.allSubjectExpedition.push(...resp.data.results);
        this.getAllMapCountries();
      }
    }, Error => {
      console.log('Err is ', Error);
      this.loaderService.display(false);
    });
  }

  sdgChangeExpedition(selectedId) {
    this.allSdgExpedition.forEach(element => {
      if (element.id == selectedId) {
        this.selectedSdgExpedition = element.name;
        this.selectedSdgImageExpedition = element.image
      }
    });
    this.questionParams.sdg = selectedId;
    console.log(this.questionParams.sdg)
    this.loaderService.display(true);
    if (this.isLoggedIn) {
      this.getQuestionList();
    } else {
      this.getQuestionPublicList();
    }
    // this.getQuestionStatus();
  }
  countryChangeExpedition(selectedId) {
    this.lstCountriesExpedition.forEach((element: any) => {
      if (element.id == selectedId) {
        console.log(element)
        this.selectedCountryExpedition = element.name;
        this.selectedCountryImageExpedition = element.image
      }
    });
    this.questionParams.country = selectedId;
    this.loaderService.display(true);
    if (this.isLoggedIn) {
      this.getQuestionList();
    } else {
      this.getQuestionPublicList();
    }
    // this.getQuestionStatus();
  }
  // subjectChangeExpedition(selectedId) {
  //   this.allSubjectExpedition.forEach(element => {
  //     if (element.id == selectedId) {
  //       this.selectedSubjectExpedition = element.name;
  //     }
  //   });
  //   this.questionParams.subject = selectedId;
  //   this.loaderService.display(true);
  //   if (this.isLoggedIn) {
  //     this.getQuestionList();
  //   } else {
  //     this.getQuestionPublicList();
  //   }
  //   // this.getQuestionStatus();
  // }
  difficultyChangeExpedition(selectedId) {
    this.allDifficultyExpedition.forEach(element => {
      if (element.id == selectedId) {
        this.selectedDifficultyExpedition = element.name;
      }
    });
    this.selectedDifficultyIdExpedition = selectedId;
    this.questionParams.difficulty = selectedId;
    this.loaderService.display(true);
    if (this.isLoggedIn) {
      this.getQuestionList();
    } else {
      this.getQuestionPublicList();
    }
    // this.getQuestionStatus();
  }

  // getQuestionList() {
  //   this.serviceData.getQuestionList(this.questionParams).subscribe((resp: any) => {
  //     if (resp.success) {
  //       let allQuestionList = resp.data.results;
  //       console.log(allQuestionList);
  //       this.lstRightQuestions = [];
  //       this.lstWrongQuestions = [];
  //       this.lstUnattendedQuestions = [];
  //       allQuestionList.forEach(element => {
  //         if (element.attempted) {
  //           if (element.is_right) {
  //             this.lstRightQuestions.push(element);
  //           } else {
  //             this.lstWrongQuestions.push(element);
  //           }
  //         } else {
  //           this.lstUnattendedQuestions.push(element);
  //         }
  //       });
  //       this.Unattended = this.translate.instant('Unattended') + '(' + this.lstUnattendedQuestions.length + ')';
  //       this.rightQuestionLabel = this.translate.instant('Right') + '(' + this.lstRightQuestions.length + ')';
  //       this.wrongQuestionLabel = this.translate.instant('Wrong') + '(' + this.lstWrongQuestions.length + ')';
  //       this.getQuestionStatus();
  //     }
  //   }, Error => {
  //     this.loaderService.display(false);
  //     console.log('Err is ', Error);
  //   });
  // }

  clearQuestionList() {
    if (this.isQuestionListClear) {
      console.log('clearQuestionList');
      this.lstRightQuestions = [];
      this.lstWrongQuestions = [];
      this.lstUnattendedQuestions = [];
      this.isQuestionListClear = false;
    }
  }

  getQuestionList() {
    this.questionTabIndex = 0;
    this.questionParams.offset = 0;
    this.isQuestionListClear = true;
    if (this.isLoggedIn) {
      this.getQuestionStatus();
      this.onUnattendedScroll();
      setTimeout(() => {
        this.onWrongScroll();
        this.onRightScroll();
      }, 1500);
    } else {
      this.getQuestionPublicStatus();
      this.onPublicQuestionScroll();
    }
  }

  onQuestionScroll() {
    if (!this.infinityLoader) {
      if (this.isLoggedIn) {
        if (this.questionTabIndex == 0) {
          this.onUnattendedScroll();
        } else if (this.questionTabIndex == 1) {
          this.onWrongScroll();
        } else if (this.questionTabIndex == 2) {
          this.onRightScroll();
        }
      } else {
        this.onPublicQuestionScroll();
      }
    }
  }

  onUnattendedScroll() {
    this.infinityLoader = true;
    if (!this.isQuestionListClear) {
      this.questionParams.offset = this.lstUnattendedQuestions.length;
    }
    this.serviceData.getUnansweredQuestionList(this.questionParams).subscribe((resp: any) => {
      if (resp.success) {
        this.clearQuestionList();
        this.lstUnattendedQuestions.push(...resp.data.results);
        this.Unattended = resp.data.count;
      }
      this.infinityLoader = false;
    }, Error => {
      this.infinityLoader = false;
      this.loaderService.display(false);
      console.log('Err is ', Error);
    });
  }

  onWrongScroll() {
    this.infinityLoader = true;
    if (!this.isQuestionListClear) {
      this.questionParams.offset = this.lstWrongQuestions.length;
    }
    this.serviceData.getWrongQuestionList(this.questionParams).subscribe((resp: any) => {
      if (resp.success) {
        this.lstWrongQuestions.push(...resp.data.results);
        this.wrongQuestionLabel = resp.data.count;
        this.infinityLoader = false;
      }
    }, Error => {
      this.infinityLoader = false;
      this.loaderService.display(false);
      console.log('Err is ', Error);
    });
  }

  onRightScroll() {
    this.infinityLoader = true;
    if (!this.isQuestionListClear) {
      this.questionParams.offset = this.lstRightQuestions.length;
    }
    this.serviceData.getRightQuestionList(this.questionParams).subscribe((resp: any) => {
      if (resp.success) {
        this.lstRightQuestions.push(...resp.data.results);
        this.rightQuestionLabel = resp.data.count;
      }
      this.infinityLoader = false;
    }, Error => {
      this.infinityLoader = true;
      this.loaderService.display(false);
      console.log('Err is ', Error);
    });
  }

  getQuestionStatus() {
    this.serviceData.getQuestionStatus(this.questionParams).subscribe((resp: any) => {
      if (resp.success) {
        console.log(resp.data);
        this.questionStatus = resp.data;
      }
      this.loaderService.display(false);
    }, Error => {
      this.loaderService.display(false);
      console.log('Err is ', Error);
    });
  }

  getParticipantData() {
    this.serviceData.getParticipantData().subscribe((resp: any) => {
      if (resp.success) {
        console.log(resp.data);
        this.participantData = resp.data;
        this.getQuestionList();
      }
    }, Error => {
      this.loaderService.display(false);
      console.log('Err is ', Error);
    });
  }

  getAllMapCountries() {
    this.serviceData.getCountriesMap().subscribe((resp: any) => {
      if (resp.success) {
        console.log(resp.data.results);
        this.lstExpeditionMap = resp.data.results;
        this.lstExpeditionMap.forEach(element => {
          if (element.info.score_percentage < 20) {
            element.upComingBadge = 'bronze';
            let x = Math.ceil(((20 * element.info.maximum_score) / 100) - element.info.score);
            element.pointNeed = x;
          } else if (element.info.score_percentage >= 20 && element.info.score_percentage < 40) {
            element.upComingBadge = 'silver';
            let x = Math.ceil(((40 * element.info.maximum_score) / 100) - element.info.score);
            element.pointNeed = x;
          } else if (element.info.score_percentage >= 50 && element.info.score_percentage < 75) {
            element.upComingBadge = 'gold';
            let x = Math.ceil(((75 * element.info.maximum_score) / 100) - element.info.score);
            element.pointNeed = x;
          }
        });
        // this.lstExpeditionMap.forEach(country => {
        //   this.expeditionLat = +country.latitude;
        //   this.expeditionLong = +country.longitude;
        // });
        // this.expeditionLat = this.expeditionLat / this.lstExpeditionMap.length;
        // this.expeditionLong = this.expeditionLong / this.lstExpeditionMap.length;
        this.getSdgBannerList();
      }
    }, Error => {
      this.loaderService.display(false);
      console.log('Err is ', Error);
    });
  }
  getSdgBannerList() {
    this.serviceData.getSDGlist().subscribe((resp: any) => {
      if (resp.success) {
        console.log(resp.data)
        this.lstAllSDGBanner = resp.data.results;
        this.lstAllSDGBanner.forEach(element => {
          element['bannerClicked'] = false;
          // element.info.percentage = Math.round((element.info.answered_questions / element.info.total_questions) * 100);
          if (element.info.score_percentage < 20) {
            element.upComingBadge = 'bronze';
            let x = Math.ceil(((20 * element.info.maximum_score) / 100) - element.info.score);
            element.pointNeed = x;
          } else if (element.info.score_percentage >= 20 && element.info.score_percentage < 40) {
            element.upComingBadge = 'silver';
            let x = Math.ceil(((40 * element.info.maximum_score) / 100) - element.info.score);
            element.pointNeed = x;
          } else if (element.info.score_percentage >= 40 && element.info.score_percentage < 75) {
            element.upComingBadge = 'gold';
            let x = Math.ceil(((75 * element.info.maximum_score) / 100) - element.info.score);
            element.pointNeed = x;
          }
        });
        this.getParticipantData();
      }
    }, Error => {
      this.loaderService.display(false);
      console.log('Err is ', Error);
    });
  }

  expditionMapReady(e) {
    console.log(e);
    const bounds: LatLngBounds = new google.maps.LatLngBounds();
    for (let marker of this.lstExpeditionMap) {
      bounds.extend(new google.maps.LatLng(marker.latitude, marker.longitude));
    }
    e.fitBounds(bounds);
    setTimeout(() => {
      this.mapDiv.nativeElement.style.paddingTop = this.mapHeader.nativeElement.offsetHeight + 13 + 'px';
      // this.resizeExpeditionMap();
    }, 1000);
  }

  setQnTrayHeight() {
    setTimeout(() => {
      this.expeditionTab.nativeElement.style.height = Math.round(window.innerHeight) - (this.tabSelected.nativeElement.offsetHeight + 228) + 'px';
    }, 1000);
  }

  setVideoTrayHeight() {
    setTimeout(() => {
      this.divToScroll.nativeElement.style.height = Math.round(window.innerHeight) - (this.tabSelected.nativeElement.offsetHeight + 375) + 'px';
    }, 1000);
  }

  // open Sustainable development goals
  openSdg() {
    const dialogRef = this.dialog.open(AllQuestionModalComponent, {
      disableClose: true,
      width: '1023px',
      maxWidth: '85vw',
      // height: 'auto',
      minHeight: '60vh',
      maxHeight: '80vh',
      data: this.lstAllSDGBanner
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result)
      if (result != undefined) {
        this.viewSdgQuestions(result)
      }
    });
  }

  introModalOpen(hideSkip = false) {
    const dialogRef = this.dialog.open(IntroModalComponent, {
      disableClose: true,
      width: '680px',
      height: 'auto',
      maxHeight: '90vh',
      panelClass: 'custom-dialog-container',
      data: { 'hideSkip': hideSkip }
    });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed', result);
      if (this.isExpedition) {
        this.getSdgFilter();
      }
      // this.getSdgFilter();
    });
  }

  quizScrollToTop() {
    if (this.expeditionTab?.nativeElement) {
      this.expeditionTab.nativeElement.scrollTop = 0;
    }
  }

  ngOnDestroy() {
    // if (this.reloadSubscription) {
    //   this.reloadSubscription.unsubscribe();
    // }

    if (this.selectedLanguageSubscriber) {
      this.selectedLanguageSubscriber.unsubscribe();
    } {

    }
  }

}



